import colors from "@digits-shared/themes/colors"
import fonts, { BodyText } from "@digits-shared/themes/typography"
import styled from "styled-components"

export const FlowAmount = styled(BodyText)`
  color: ${colors.secondary};
  overflow: hidden;
  text-overflow: ellipsis;

  &.heading {
    font-weight: ${fonts.weight.heavy};
  }

  &:not(.no-colors).abnormal {
    &.inbound {
      color: ${colors.primary};
    }

    &.outbound {
      color: rgba(215, 104, 0, 1);
    }
  }

  &.negative::before {
    content: "-";
  }
`
